import { ImpactClient } from "../../../../Wrap/Api/Impact/Impact";
import { ImpactRedirectType } from "../../../../Wrap/Models/Domains/Impact/ImpactRedirectType";
import AdviserSiteTagManager, { eventCategoryForGTM } from "../../Cookies/ChoicesCookie/AdviserSiteTagManager";

export class ImpactRedirectAction {
    public static redirectToImpact(clAccountId: string, redirectType: ImpactRedirectType) {
        this.addGtmEvent(redirectType);

        ImpactRedirectAction.get(clAccountId, redirectType, (url) => {
            window.open(url, '_blank').focus();
        });
    }

    private static addGtmEvent(redirectType: ImpactRedirectType) {
        const { addEvent } = new AdviserSiteTagManager();

        const redirectLocation = redirectType === ImpactRedirectType.Reporting ? 'reporting' : 'esg tab';
        
        addEvent({
            event: "esg_hub_interactions",
            eventParameters: {
                eventAction: "interactions",
                eventCategory: eventCategoryForGTM.esgAnalyserTab,
                eventLabel: `esg hub > ${redirectLocation} > launch esg hub`,
            },
        });
    }
	
    private static get(clAccountId: string, redirectType: ImpactRedirectType, callback?: (url: string) => any): void {
        const client = new ImpactClient();
        const promise = client.get(clAccountId, redirectType);
        promise.onSuccess((result) => {
            if (callback) {
                callback(result);
            }
        });

        promise.onError((err) => {
            console.error(err);
        });
    }
}
